import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { MarcaProductoSelectInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProductoSelect.interface";

export async function FindAllMarcaProductoSelectAction(): Promise<
  ApiResponse<MarcaProductoSelectInterface>
> {
  const { data } = await apiClient.get<MarcaProductoSelectInterface>(
    "/gpMarcaProductos/select"
  );
  return {
    status: 200,
    data,
    message: "Marca de producto obtenidas correctamente",
  };
}
